var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 13" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M7.2 12.5c-.3 0-.7-.1-.9-.3L1 7.9C.3 7.4.2 6.5.6 5.8S2 5 2.7 5.4c.1 0 .1.1.2.1l4.2 3.4 7-7.9c.6-.6 1.5-.7 2.1-.1.6.6.7 1.5.1 2.1l-8 9c-.3.3-.7.5-1.1.5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Ok.svg